// extracted by mini-css-extract-plugin
module.exports = {"openModalBtn":"ChangeClinic_openModalBtn__1Nc5j","footer":"ChangeClinic_footer__2gz2B"};